<template>
    <div v-if="pool != null">
        <div v-if="userProfile != null">
            <div class="card shadow-sm border-0 mb-3">
                <div class="card-body p-4">
                    <div class="row">
                        <div class="col">
                            <div class="d-flex align-items-start">
                                <h5 class="font-weight-bold mr-2">{{ pool.name }} </h5> 
                                <!-- {{ canContribute }} -->
                                <div class="dropdown dropleft ml-auto">
                                
                                        <a class="pl-3" id="dropdownMenuButton" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-ellipsis-v"></i>
                                        </a>
                                    
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="#" data-toggle="modal" data-target="#exampleModal">
                                            Share
                                        </a>

                                        <router-link 
                                            v-if="isConvener"
                                            class="dropdown-item" 
                                            :to="{ name: 'initiate-payout', params: { pool_id: pool_id }}" 
                                            tag="a">
                                            Initiate Payout
                                        </router-link>

                                        <div v-if="invite_detail != null  && canContribute">
                                            <router-link 
                                                class="dropdown-item" 
                                                :to="{ name: 'accept-invite', params: { pool_id: invite_detail.pool_id, invite_code: invite_detail.invite_id }}" 
                                                tag="a">
                                                Make Contribution
                                            </router-link>
                                        </div>
                                        <a v-show="isConvener" data-toggle="modal" data-target="#closePoolModal" class="dropdown-item">Close Pool</a>
                                    </div>
                                </div>
                            
                            </div>
                            <div class="d-flex mb-4">
                                <p class="p-0 mb-1">{{ pool.description }}</p>
                            </div>
                            <div class="row no-gutters">
                                <div class="col-lg-3 col-md-6">
                                    <div class="">
                                        <small class="my-1 py-0 text-secondary">Collection Amount</small>
                                        <h5 class="font-weight-bold mt-0  py-0">&#8358;{{ pool.total_amount | moneyformat }}</h5>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-6">
                                    <div>
                                        <small class="my-1 py-0 text-secondary">Received</small>
                                        <h5 class="font-weight-bold text-success mt-0 py-0"> &#8358;{{ pool.contributed_amount | moneyformat }}</h5>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-md-6">
                                    <div class="">
                                        <small class="my-1 py-0 text-secondary">Contribution Deadline</small>
                                        <h5 class="font-weight-bold mt-0  py-0">{{ pool.contribution_deadline | dayDateFormat  }}</h5>
                                    </div>

                                </div>
                                <div class="col-lg-2 col-md-6">
                                    <div class="">
                                        <small class="my-1 py-0 text-secondary">Contributions</small>
                                        <h5 class="font-weight-bold mt-0  py-0">{{ `${pool.contributions}/${pool.member_count}` }}</h5>
                                    </div>

                                </div>

                            </div>

                            <div class="d-md-flex mt-3">
                                <div v-if="pool_convener != null">
                                    <small class="text-muted mb-4">Organized by <span class="">{{ poolConvenerName }}</span></small>
                                </div>
                                <div class="ml-auto">
                                    <small class="ml-auto text-muted"> {{ pool.updated_at | dayDateFormat }}</small>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="row mt-3">
            <contributors-feed
                v-if="contributors != null"
                :contributors="contributors"
                :pool="pool">
            </contributors-feed>

            <div class="col-lg-4 col-12">
                <div class="card border-0 shadow-sm mb-3" v-if="pool.payout_rule == 'majority-vote'">
                    <div class="card-body py-3"> 
                        <p class="text-center mb-3 h6">Payout Rule
                            <span class="badge badge-light">{{ pool.payout_rule }}</span>
                        </p>

                        <div class="row text-center pb-3" style=" border-bottom:  1px solid #eee;" v-if="payout_request_info != null">
                            <div class="col-6 ">
                                <h5 class="m-0 font-weight-bold" >{{ payoutStat.votes_received }}/{{ payoutStat.member_count}}</h5>
                                <small class="text-muted">Votes Received</small>
                            </div>
                            <div class="col-6">
                                <h5 class="m-0 font-weight-bold">{{ payoutStat.approval_percentage }}%</h5>
                                <small class="text-muted">Approval</small>
                            </div>
                        </div>
                        <div class="modalBtn mt-2">
                            <button 
                                class="btn btn-link btn-block btn-sm" 
                                role="button" 
                                data-backdrop="static" 
                                data-keyboard="false" 
                                data-toggle="modal" 
                                data-target="#initiatePayoutModal">
                                Payout details
                            </button>
                        </div>
                    </div>
                </div>
                
                <div class="card border-0 shadow-sm mb-3" v-if="pool.payout_rule == 'organizer-autonomy'">
                    <div class="card-body py-3"> 
                        <p class="text-center mb-3 h6 ft-14">Payout Rule: 
                            <span class="badge badge-light">{{ pool.payout_rule }}</span>
                        </p>

                        <div class="text-center">
                            ---
                        </div>
                        <div class="modalBtn mt-2">
                            <button 
                                class="btn btn-link btn-block btn-sm" 
                                role="button" 
                                data-backdrop="static" 
                                data-keyboard="false" 
                                data-toggle="modal" 
                                data-target="#initiatePayoutModal">
                                Payout details
                            </button>
                        </div>
                    </div>
                </div>

                <recent-activity-feed
                    v-if="contributors != null"
                    :pool_id="pool_id"
                    :contributors="contributors">
                </recent-activity-feed>
            </div>
        </div>

                <!-- Modal -->
        <div class="modal fade" ref="approve_payout_modal" id="initiatePayoutModal" tabindex="-1" role="dialog" aria-labelledby="initiatePayoutModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h6 class="modal-title" id="initiatePayoutModalLabel">Payout</h6>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="card-body p-0" v-if="pool.payout_rule == 'organizer-autonomy'">
                            <div class="" v-if="oa_payout_info != null">
                                <div class="col-12 p-0">
                                    <div class="d-flex align-items-center justify-content-center mb-1" v-if="pool_convener != null">
                                        <img src="@/assets/avatar-purple.png" class="mr-2" alt="" style="height: 40px;">
                                        <h6 class=" m-0 p-0 ">{{ poolConvenerName }}</h6>

                                    </div>
                                    <p class="text-center small"> has selected the following as payout recipients of this pool: </p>
                                </div>

                                <!-- <h6 class="font-weight-bold">Payout Recipients</h6> -->
                                <div class="text-center pb-3" v-if="oa_payout_info != null">

                                    <table class="table table-responsive">
                                        <thead>
                                                <!-- <tr class="">
                                                    <th scope="col">#</th>
                                                    <th scope="col"></th>
                                                    <th scope="col"> </th>
                                                    <th scope="col" style="width: 500px;"> </th>
                                                    <th scope="col" v-if="pool.payout_rule == 'majority-vote'">Payout Vote</th>
                                                </tr> -->
                                        </thead>
                                        <tbody>
                                            
                                            <tr v-for="(payout_info, index) in oa_payout_info" :key="index">
                                                <div class="d-flex align-items-center">

                                                    <td class="" >
                                                            <div class="avatar-container">
                                                                <img src="@/assets/avatar-purple.png" class="avatar" alt="avatar" style="height:40px; width: 40px;">
                                                            </div>

                                                    </td>
                                                    <td class="" style="min-width: 250px">
                                                        <div class="d-flex justify-content-start">
                                                            <p class="my-0 mr-3 h6">
                                                                {{ payout_info.profile.lastname}} {{ payout_info.profile.firstname }}
                                                            </p>

                                                        </div>
                                                    </td>
                                                    <td class=""> 
                                                        <div>
                                                            <p class="my-0 h6 text-success font-weight-bold"> &#8358;{{ payout_info.amount | moneyformat }}</p>
                                                        </div>
                                                    </td>
                                                </div>

                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                                <div class="text-center pb-3" v-else>
                                    <p><span class="fa fa-exclamation-circle"></span> No recipients has been added for payout</p>
                                </div>
                            </div>
                            <div class="text-center py-4" v-else>
                                <p class="h6"> <span class="fa fa-exclamation-circle"></span> No payout recipient has been added</p>
                            </div>
                        </div>

                        <div class="card-body p-0" v-if="pool.payout_rule == 'majority-vote'">
                            <div class="" v-if="payout_candidates != null">
                                <div class="p-0 mb-3" v-if="payout_candidates.length > 0">
                                    <div class="col-12 p-0" v-if="pool_convener != null">
                                        <div class="d-flex align-items-center justify-content-center mb-1">
                                            <img src="@/assets/avatar-purple.png" class="mr-2" alt="" style="height: 40px;">
                                            <h6 class=" m-0 p-0">{{ poolConvenerName }}</h6>

                                        </div>
                                        <p class="text-center small"> has selected the following as payout recipients of this pool: </p>
                                    </div>

                                    <div class="col-12 p-0 mb-4">
                                        <div class="payout_recipients">
                                            <table class="table table-responsive">
                                                <thead>
                                                        <!-- <tr class="">
                                                            <th scope="col">#</th>
                                                            <th scope="col"></th>
                                                            <th scope="col"> </th>
                                                            <th scope="col" style="width: 500px;"> </th>
                                                            <th scope="col" v-if="pool.payout_rule == 'majority-vote'">Payout Vote</th>
                                                        </tr> -->
                                                </thead>
                                                <tbody>
                                                    
                                                    <tr class="d-flex" v-for="(payout_candidate, index) in payout_candidates" :key="index">
                                                        <td class="" style="width: 80px;">
                                                                <div class="d-flex align-items-center p-0">
                                                                    <img src="@/assets/avatar-purple.png" class="avatar" alt="avatar" style="width: 40px;">
                                                                </div>
                                                        </td>
                                                        <td class="" style="width: 200px;">
                                                            <div class="d-flex align-items-center flex-wrap">
                                                                <p class="my-0 mr-3 h6">
                                                                    {{ payout_candidate.user.profile.lastname }} {{ payout_candidate.user.profile.firstname }}
                                                                </p>

                                                            </div>
                                                        </td>
                                                        <td class="" style="width: 200px"> 
                                                            <p class="my-0 h6 text-success font-weight-bold"> &#8358;{{ payout_candidate.amount | moneyformat }}</p>
                                                        </td>

                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                    <div class="col-12" v-show="user_payout_approval_status == null">
                                        <button 
                                            class="btn btn-custom btn-block btn-sm mb-3" 
                                            @click.prevent="approvePayoutCandidate()">
                                            Approve
                                        </button>
                                    
                                        <button 
                                            class="btn btn-link btn-block btn-sm"
                                            @click.prevent="declinePayoutCandidate()">
                                            Decline
                                        </button>

                                    </div>

                                    <div class="col-12" v-if="user_payout_approval_status != null">
                                        <h6 class="text-center">
                                            <span class="fa" 
                                                :class="{'fa-check-circle': payoutApproved, 'fa-times-circle': payoutDeclined}">
                                            </span> 
                                            You have already {{ user_payout_approval_status.vote }} this payout request.
                                        </h6>
                                    </div>
                                </div>
                                <!-- <div class="card-body" v-if="payout_candidates.length == 0">
                                    <h6 class="text-center"> 
                                        <span class="fa fa-exclamation-circle"></span> No payout recipient has been selected.
                                    </h6>
                                </div> -->
                            </div>
                            <div class="text-center py-4" v-else>
                                <p class="h6"> <span class="fa fa-exclamation-circle"></span> No payout recipient has been added</p>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light btn-sm" data-dismiss="modal">Close</button>
                        <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="closePoolModal" tabindex="-1" role="dialog" aria-labelledby="closePoolModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h6 class="modal-title" id="initiatePayoutModalLabel">Close Pool</h6>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <h6 class="py-4 text-center">Are you sure you want to close this pool?</h6>
                    </div>
                    <div class="modal-footer d-flex">
                        <button type="button" class="btn btn-custom-sm mr-2" @click.prevent="closePool()">Yes </button>
                        <button type="button" class="btn btn-light" data-dismiss="modal">No</button>
                    </div>
                </div>
            </div>
        </div>

        <social-share :poolLink="poolLink"></social-share>
    </div>
  
</template>

<script>
import { mapGetters } from 'vuex'
import ContributorsFeed from '@/components/ContributorsFeed'
import RecentActivityFeed from '@/components/RecentActivityFeed'
import SocialShare from '@/components/SocialShare'

export default {
    name: 'ViewPool',
    components: { 
        ContributorsFeed,
        RecentActivityFeed,
        SocialShare
    },
    data() {
        return {
            pool_id: this.$route.params.pool_id,
        }
    },
    computed: {
        ...mapGetters({
            pool: 'pool',
            contributors: 'pool_invitees',
            userProfile: 'userProfile',
            pool_convener: 'pool_convener',
            payout_candidates: 'payout_candidates',
            payout_request_info: 'payout_request_info',
            user_payout_approval_status: 'user_payout_approval_status',
            oa_payout_info: 'oa_payout_info',
            invite_detail: 'invite_detail',
            pool_contributors: 'pool_contributors',
            pool_disbursed_info: 'pool_disbursed_info'
        }),

        poolLink() {
            return window.location.origin + '/pool/share/'+ this.pool_id
        },

        isConvener() {  
            let pool = this.pool;

            if (pool == null) {
                return false
            } else {
                return pool.account_id != this.userProfile.account_id ? false : true
            }
        },

        payoutStat() {
            const { accepted_count, declined_count } = this.payout_request_info;
            const { member_count } = this.pool;

            return {
                approval_percentage: ((parseInt(accepted_count)/ parseInt(member_count)) * 100).toFixed(1),
                accepted_count,
                declined_count,
                member_count,
                votes_received: parseInt(accepted_count) + parseInt(declined_count)
            }
        },
        
        amountContributed() {
            const { contributions, member_count } = this.pool;

            const result = (contributions / member_count) * 100;
            const chart = result/10;

            return {
                percentage: parseInt(result),
                chartCount: parseInt(chart)
            }
        },
        poolConvenerName() {
            const { firstname, lastname } = this.pool_convener.profile;

            return `${lastname} ${firstname}`;
        },
        payoutApproved() {
            const { vote } = this.user_payout_approval_status;

            return vote == 'approved' ? true : false;
        },
        payoutDeclined() {
            const { vote } = this.user_payout_approval_status;

            return vote == 'declined' ? true : false;
        },
        canContribute() {
            const { payout_rule } = this.pool;

            if (this.contributors != null) {
    
                const { members } =  this.contributors;
    
                // check if user has already contributed
                const invited_user = members.filter(invitee => invitee.email == this.userProfile.email);
        
                if (invited_user.length == 1) {
                    return invited_user.paid_status == true ? false : true;
                } else {
                    return false
                }

            }
        }
    },
    created() {
        this.$store.dispatch('getPool', this.pool_id)
        this.$store.dispatch('listPaidContributors', this.pool_id)
    },
    watch: {
        pool() {
            this.$store.dispatch('listInvitedContributors', this.pool.pool_id);

            this.$store.dispatch('getPoolConvener', this.pool.account_id);

            this.$store.dispatch('getPayoutCandidates', this.pool.pool_id);

            if (this.pool.payout_rule == 'majority-vote') {
                this.$store.dispatch('payoutRequestInfo', this.pool_id);
            }
            
            if (this.pool.payout_rule == 'organizer-autonomy') {
                this.$store.dispatch('getOrgAutonomyInfo', this.pool_id);
            }
        },
        payout_candidates() {
            this.$store.dispatch('getPayoutVotesInfo', this.userProfile.account_id);
            this.$store.dispatch('getDisbursedPayouts', this.pool_id);
        },
    },

    methods: {
        async closePool() {
            try {
                const pool = await axios.post('/pool/close', { pool_id: this.pool_id });
                console.log(pool);

                if (pool.status == 200) {
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Success',
                        text: 'Pool has been closed successfully'
                    });
                }
            } catch (error) {
                console.log(error.response);
            }
        },
        async approvePayoutCandidate() {
            const data = {
                payout_request_id: this.payout_request_info.candidates[0].payout_request_id,
                account_id: this.userProfile.account_id,
                vote: 'approved'
            };

            try {
                const approve = await axios.post('/pool/payout/request/approve', data)

                if (approve.status == 200 && approve.data.status == 'ok') {
                    $(this.$refs.approve_payout_modal).modal('hide');

                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Success',
                        text: 'You have approved the payout recipients for this pool.'
                    });
                    
                    this.$router.go();

                }

            } catch (error) {
                console.log(error.response)
            }
        },
        async declinePayoutCandidate() {
            const data = {
                payout_request_id: this.payout_request_info.candidates[0].payout_request_id,
                account_id: this.userProfile.account_id,
                vote: 'declined'
            };

            try {
                const decline = await axios.post('/pool/payout/request/decline', data);

                if (decline.status == 200 && decline.data.status == 'ok') {
                    $(this.$refs.approve_payout_modal).modal('hide');
                    
                    this.$router.go();

                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Success',
                        text: 'You have declined the payout recipients for this pool.'
                    });

                }
            } catch (error) {
                // console.log(error.response)
            }
        },
    }

}
</script>

<style>
.avatar {
  vertical-align: middle;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

</style>